import { render, staticRenderFns } from "./BaseWallet.vue?vue&type=template&id=553f83bc&scoped=true&"
import script from "./BaseWallet.vue?vue&type=script&lang=js&"
export * from "./BaseWallet.vue?vue&type=script&lang=js&"
import style0 from "./BaseWallet.vue?vue&type=style&index=0&id=553f83bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553f83bc",
  null
  
)

export default component.exports